import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-sm" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (o, i) => {
      return (_openBlock(), _createElementBlock("span", {
        key: i,
        onClick: ($event: any) => (_ctx.$emit('update:modelValue', i)),
        class: "font-bold"
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["cursor-pointer underline", [_ctx.modelValue === i ?'text-next-atp decoration-next-atp': 'hover:text-next-orange']])
        }, _toDisplayString(o), 3),
        (i !== _ctx.options.length-1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, " / "))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}